import { render, staticRenderFns } from "./DevOpsPublicCom.vue?vue&type=template&id=28864d46&scoped=true"
import script from "./DevOpsPublicCom.vue?vue&type=script&lang=js"
export * from "./DevOpsPublicCom.vue?vue&type=script&lang=js"
import style0 from "./DevOpsPublicCom.vue?vue&type=style&index=0&id=28864d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28864d46",
  null
  
)

export default component.exports